import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import storage from '../../../apis/Storage'
import {
  GET_VERSIONS,
  ADD_VERSION,
  DELETE_VERSION,
  UPDATE_VERSION,
} from '../../../Types'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export const getVersions = () => async (dispatch) => {
  await axios
    .get(`api/AppVersion`)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_VERSIONS,
        payload: data.response,
      })
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const addVersion = (formValues) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post('api/AppVersion', formValues)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: ADD_VERSION,
          payload: data.response,
        })
      dispatch(hideLoading())
      toast.success('App Version added successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      } else toast.error('Error while processing the request')
    })
}

export const deleteVersion = (id) => async (dispatch) => {
  const config = {
    headers: { Authorization: `Bearer ${storage.get('_appToken')}` },
  }

  await axios
    .delete(`api/AppVersion/${id}`, config)
    .then(() => {
      toast.success('App version deleted successfully')
      dispatch({ type: DELETE_VERSION, payload: id })
    })
    .catch(function (error) {
      dispatch(hideLoading())
      toast.error('Error: ' + error)
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const updateVersion = (id, formValues) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .put(`api/AppVersion/${id}`, formValues)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: UPDATE_VERSION,
          payload: data.response,
        })
      dispatch(hideLoading())
      toast.success('App Version updated successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      } else toast.error('Error while processing the request')
    })
}
